var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBatteryNullIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 18.985H44V28.985H40V31C40 31.7956 39.6839 32.5587 39.1213 33.1213C38.5587 33.6839 37.7957 34 37 34H7C6.20435 34 5.44129 33.6839 4.87868 33.1213C4.31607 32.5587 4 31.7956 4 31V17C4 16.2044 4.31607 15.4413 4.87868 14.8787C5.44129 14.3161 6.20435 14 7 14H37C37.7957 14 38.5587 14.3161 39.1213 14.8787C39.6839 15.4413 40 16.2044 40 17V18.985ZM37.7071 31.7071C37.8946 31.5196 38 31.2652 38 31V17C38 16.7348 37.8946 16.4804 37.7071 16.2929C37.5196 16.1054 37.2652 16 37 16H7C6.73478 16 6.48043 16.1054 6.29289 16.2929C6.10536 16.4804 6 16.7348 6 17V31C6 31.2652 6.10536 31.5196 6.29289 31.7071C6.48043 31.8946 6.73478 32 7 32H37C37.2652 32 37.5196 31.8946 37.7071 31.7071ZM22 22.571L26.243 18.328L27.657 19.742L23.414 23.985L27.657 28.229L26.243 29.643L22 25.4L17.758 29.642L16.344 28.228L20.586 23.985L16.344 19.742L17.758 18.328L22 22.571Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBatteryNullIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/BatteryNull_icon.60ec9b872031fc5f3d26a9c11fd88c85.svg";